import React, { useState } from "react";
import Select from "react-select";

const ReplacementReasonsSelect = (props) => {
  const reasons = [
    { value: "reasignation", label: "Renuncia" },
    { value: "disengagement", label: "Desvinculación" },
    { value: "relocation", label: "Movilidad Interna" }
  ];

  const [replacementReason] = useState(reasons);

  const handleChangeReasons = inputValue => {
    props.handleChange(inputValue, "replacementReason");
  };

  return (
    <Select
      inputId="replacementReason"
      onChange={handleChangeReasons}
      options={replacementReason}
      placeholder="Seleccione una opción"
      value={replacementReason.find(
        (option) => option.value === props.value?.value
      ) || null}
    />
  );
};

export default ReplacementReasonsSelect;
